import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  > h1 {
    margin-left: 90px;
    margin-top: 15px;
    font-weight: 600;
    color: ${({ theme }) => theme.text};
    font-size: 1.75rem;
  }

  > div {
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 675px) {
      flex-direction: column;
    }

    height: 100%;
  }
`;

export const LeagueInfo = styled.aside`
  flex: 9;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;

  > span {
    max-width: 230px;

    fieldset {
      legend {
        font-weight: 600;
        font-size: 1.5rem;
        margin: 0;
      }

      input {
        border: solid 2px ${({ theme }) => theme.black};
        border-radius: 2px;
        font-size: 1.75rem;
        padding: 0 12px;
        width: 230px;
        color: ${({ theme }) => theme.black};
      }
    }

    > div {
      display: flex;
      align-items: center;
      margin-top: 16px;

      p {
        font-weight: 600;
        font-size: 1.5rem;
        margin: 0;
        margin-right: 1rem;
      }

      .ant-select {
        width: 125px;
        font-size: 1.25rem;
      }
    }
  }
`;

export const Users = styled.aside`
  flex: 9;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: -4rem;

  h1 {
    font-size: 1.75rem;
    font-weight: 600;
    margin: 0;
    margin-bottom: 10px;

    color: ${({ theme }) => theme.purple};
  }

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    max-height: 550px;
    width: 95%;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  @media (max-width: 1600px) {
    div {
      max-height: 400px;
    }
  }

  @media (max-width: 1024px) {
    > div {
      max-height: 250px;
    }
  }

  @media (max-width: 912px) {
    > div {
      max-height: 650px;
    }
  }

  @media (max-width: 820px) {
    > div {
      max-height: 450px;
    }
  }

  @media (max-width: 675px) {
    margin-top: 0rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 230px;
  width: 100%;
  margin-top: 1rem;
  transition: filter 0.2s;

  button {
    border: 0;
    color: ${({ theme }) => theme.background};
    font-size: 1.5rem;
    flex: 1;

    &:first-child {
      background: ${({ theme }) => theme.green};

      &:hover:disabled {
        background: ${({ theme }) => theme.green};
        color: #fff;
      }
    }

    &:last-child {
      background: ${({ theme }) => theme.red};

      &:hover:disabled {
        background: ${({ theme }) => theme.red};
        color: #fff;
      }
    }

    & + button {
      margin-top: 4px;
    }

    &:hover:not(:disabled) {
      filter: brightness(0.9);
      color: ${({ theme }) => theme.background};
    }

    &:disabled {
      color: #fff;
    }
  }
`;
